module.exports = __webpack_public_path__ + "img/normal-you1.f07d69a4.png";